import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { financeApi } from "../../../finance-api-client";
import { queryKeys } from "../../query-keys";

export function useReminderConfig(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.reminderConfig(clubId ?? ""),
		queryFn: () => financeApi.reminders.getConfig(clubId!),
		enabled: !!clubId,
	});
}

export function useUpdateReminderConfig(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (data: unknown) => financeApi.reminders.updateConfig(clubId, data),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.reminderConfig(clubId),
			}),
	});
}
